import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=2e7d37ff&scoped=true&"
import script from "./commerce.vue?vue&type=script&lang=js&"
export * from "./commerce.vue?vue&type=script&lang=js&"
import style0 from "./commerce.vue?vue&type=style&index=0&id=2e7d37ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d37ff",
  null
  
)

export default component.exports